module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue5.71789989.jpg";